{
  "interaction_in_progress": {
    "message": "Authorization In Progress: Complete the process on the newly opened tab, or restart your browser."
  },
  "user_cancelled": {
    "message": "Authorization window was closed: Click 'Authorize' below to retry."
  },
  "access_denied": {
    "message": "Authorization was cancelled: Click 'Authorize' below and complete the flow to use this app."
  }
}
